/**
 * Created by b032151 on 6/22/2017.
 */
import createReactClass from "create-react-class";
import React from "react";
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Modal,
} from "react-bootstrap";
import { AutoSizer, Column, SortIndicator, Table } from "react-virtualized";
import { ServerActions } from "../../actions/serverActions";
import { SlsActions } from "../../actions/slsActions";
import { slsStore } from "../../stores/slsStore";
import { SchematicAPI } from "../../actions/schematicAPI";
import moment from "moment/moment";

function getStateFromStores() {
  return {
    slsItems: slsStore.getSlsItems(),
    slsItem: slsStore.getSlsItem(),
    isLoading: slsStore.getItemsLoading(),
    resendItem: slsStore.getResendItem(),
    resendPrintLata: "",
    disableResend: false,
    alertVisible: false,
    searching: false,
    searchBy: "controlNumber",
    historySyncId: null,
  };
}

export const SlsItemList = createReactClass({
  componentDidMount: function () {
    slsStore.subscribe(this._onChange);
    SchematicAPI.cleanup()
    SlsActions.loadSlsItems();
  },

  componentWillUnmount: function () {
    slsStore.unsubscribe(this._onChange);
  },

  getInitialState: function () {
    var newState = getStateFromStores();
    if (newState.slsItem != null) {
      newState.slsItem.restrictionDetail.trackGuids.sort(function (a, b) {
        return a.startMp - b.startMp;
      }); //Sort the guids to display
    }
    return newState;
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  refresh: function () {
    this.setState({});
  },

  _rowClassName({ index }) {
    if (index < 0) {
      return "headerRow";
    } else {
      return index % 2 === 0 ? "oddRow" : "evenRow";
    }
  },

  _noRowsRenderer() {
    return <div className="noRows">No rows found</div>;
  },
  _onRowCountChange(event) {
    const rowCount = parseInt(event.target.value, 10) || 0;

    this.setState({ rowCount });
  },

  _getDatum(list, index) {
    return list.get(index % list.size);
  },

  _onScrollToRowChange(event) {
    const { rowCount } = this.state;
    let scrollToIndex = Math.min(
      rowCount - 1,
      parseInt(event.target.value, 10)
    );

    if (isNaN(scrollToIndex)) {
      scrollToIndex = undefined;
    }

    this.setState({ scrollToIndex });
  },

  _getRowHeight({ index }) {
    const { list } = this.context;

    return this._getDatum(list, index).size;
  },

  _updateUseDynamicRowHeight(value) {
    this.setState({
      useDynamicRowHeight: value,
    });
  },
  //Filter the records form the Default track table
  _filterRecordsOfTheTable(value) {
    var dataSet = this.state.items;
    dataSet = dataSet.filter(function (item) {
      if (
        item.name
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.seq + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1
      ) {
        return true;
      }
    });
    this.setState({ filteredData: dataSet });
  },

  _headerRenderer({ dataKey, sortBy, sortDirection }) {
    return (
      <div>
        Display Order
        {sortBy === dataKey && <SortIndicator sortDirection={sortDirection} />}
      </div>
    );
  },

  _historyButtonRenderer({ cellData }) {
    return (
      <Button
        id="itemHistoryButton"
        bsStyle="link"
        value={cellData}
        onClick={this.handleHistoryButtonClick}
      >
        History
      </Button>
    );
  },

  handleHistoryButtonClick(event) {
    ServerActions.viewRequestHistory(event.target.value);
  },

  handleItemFormClose() {
    SlsActions.clearSlsItem();
  },

  handleItemFormSubmit() {
    SlsActions.updateItem(this.state.slsItem);
  },

  handleResendSubmit() {
    this.setState({ disableResend: true });
    SlsActions.resendItem(this.state.resendItem, this.state.resendPrintLata);
  },

  handleResendClose() {
    SlsActions.clearResendItem();
  },

  handleItemChange(e) {
    var newRest = this.state.slsItem;
    newRest[e.target.name] = e.target.value;
    this.setState({ slsItem: newRest });
  },

  handleItemRestrictionDetailChange(e) {
    var newRest = this.state.slsItem;
    newRest.restrictionDetail[e.target.name] = e.target.value;
    this.setState({ slsItem: newRest });
  },

  handleItemGuidChange(e) {
    var eventId = e.target.id.split("_");

    var newRest = this.state.slsItem;
    newRest.restrictionDetail.trackGuids[eventId[1]][eventId[0]] =
      e.target.value.toUpperCase();
    this.setState({ slsItem: newRest });
  },

  handleItemSubChange(e) {
    var eventId = e.target.id.split("_");

    var newRest = this.state.slsItem;
    newRest.restrictionDetail.subdivisions[eventId[1]][eventId[0]] =
      e.target.value.toUpperCase();
    this.setState({ slsItem: newRest });
  },

  handleItemDispatcherChange(e) {
    var eventId = e.target.id.split("_");

    var newRest = this.state.slsItem;
    newRest.dispatchers[eventId[1]][eventId[0]] = e.target.value;
    this.setState({ slsItem: newRest });
  },

  handleLataChange(e) {
    const lata = e.target.value;
    this.setState({ resendPrintLata: lata });
  },

  _onRowDoubleClick({ event, index, rowData }) {
    SlsActions.loadSlsItem(rowData);
  },

  handleResendButtonClick() {
    this.setState({ disableResend: false });
    SlsActions.loadResendItem();
  },

  // _onRowClick({event, index, rowData}){
  //     this.setState({rowData: rowData});
  // },

  onChange: function (event) {},

  addGuid: function (event) {
    var newState = this.state;

    newState.slsItem.restrictionDetail.trackGuids.push({
      dbVersion: "",
      endMp: 0,
      guidNumber: 0,
      mpSuffix: "",
      ptcVersion: "",
      startMp: 0,
      subdivision: this.state.slsItem.restrictionDetail.subdivision,
      trackName: "",
      isExcluded: "false",
    });

    this.setState(newState);
  },

  addSub: function (event) {
    var newState = this.state;

    newState.slsItem.restrictionDetail.subdivisions.push({
      subdivisionName: "",
      sequenceNumber: -1,
    });

    this.setState(newState);
  },

  guidRowDelete: function (event, i) {
    console.log("Delete Guid Row", event, i);
    var newState = this.state;
    newState.slsItem.restrictionDetail.trackGuids.splice(
      parseInt(event.target.id),
      1
    );
    this.setState(newState);
  },

  subRowDelete: function (event) {
    var newState = this.state;
    newState.slsItem.restrictionDetail.subdivisions.splice(
      parseInt(event.target.id),
      1
    );
    this.setState(newState);
  },

  formatValue({ cellData, dataKey, rowData }) {
    if (dataKey === "lastModifiedTimeStamp") {
      return rowData.lastModifiedTimeStamp
          ? moment(rowData.lastModifiedTimeStamp).format("MM/DD/YY HH:mm:ss.SSS")
          : "";
    }
    return "";
  },

  render: function () {
    var slsItemForm = "";
    let resendForm = "";

    var list = this.state.slsItems;

    if (this.state.slsItem != null) {
      let slsItem = this.state.slsItem;
      var storeTracks = slsItem.restrictionDetail.tracks;
      var restrictionTracks = <div className="row">No Tracks</div>;
      let restrictionText = "";
      let sortedText = slsItem.restrictionDetail.comments.sort(function (
        c1,
        c2
      ) {
        return sortFunction(c1, c2);
      });

      let text = sortedText.map(function (line) {
        return line.comment;
      });

      restrictionText = text.join("\n");

      if (storeTracks && storeTracks.length > 0) {
        restrictionTracks = storeTracks.map(function (track, i) {
          return <TrackRow key={i} track={track} ref={"row" + i} row={i} />;
        }, this);
      }

      var storeGuids = slsItem.restrictionDetail.trackGuids;
      var trackGuids = <div className="row">No GUIDS</div>;

      if (storeGuids && storeGuids.length > 0) {
        trackGuids = storeGuids.map(function (guid, i) {
          return (
            <GuidRow
              key={i}
              guid={guid}
              ref={"row" + i}
              onChange={this.handleItemGuidChange}
              rowDelete={this.guidRowDelete}
              row={i}
            />
          );
        }, this);
      }

      var storeDispatchers = slsItem.dispatchers;
      var dispatcherItems = <div className="row">No Dispatchers</div>;

      if (storeDispatchers && storeDispatchers.length > 0) {
        dispatcherItems = storeDispatchers.map(function (dispatcher, i) {
          return (
            <DispatcherRow
              key={i}
              dispatcher={dispatcher}
              ref={"row" + i}
              onChange={this.handleItemDispatcherChange}
              row={i}
            />
          );
        }, this);
      }

      let subdivisions = "";

      if (slsItem.restrictionDetail.subdivision === "MULTI") {
        let storeSubs = slsItem.restrictionDetail.subdivisions.sort(function (
            a,
            b
        ) {
          return a.sequenceNumber - b.sequenceNumber;
        });

        let subRows = storeSubs.map(function (sub, i) {
          return (
            <SubdivisionRow
              key={i}
              sub={sub}
              ref={"row" + i}
              onChange={this.handleItemSubChange}
              rowDelete={this.subRowDelete}
              row={i}
            />
          );
        }, this);

        subdivisions = (
          <div>
            <label>Subdivisions</label>
            <div className="container inheritwidth">{subRows}</div>
            <Button
              id="addSubdivisionButton"
              onClick={this.addSub}
              bsSize="small"
              bsStyle="info"
            >
              Add Sub
            </Button>
          </div>
        );
      }

      let formThree = "";
      if (
        slsItem.restrictionDetail.type === "A" ||
        slsItem.restrictionDetail.type === "B"
      ) {
        formThree = (
          <div>
            <label>TRACKS</label>
            <div className="container inheritwidth">{restrictionTracks}</div>

            <br />
            <FormGroup controlId="slsItemForm3">
              <Col componentClass={ControlLabel} sm={2}>
                Supervisor Name
              </Col>
              <Col sm={2}>
                <FormControl
                  name="supervisorName"
                  type="text"
                  value={slsItem.supervisorName}
                  onChange={this.handleItemChange}
                />
              </Col>
              <Col componentClass={ControlLabel} sm={3}>
                Phone Number
              </Col>
              <Col sm={4}>
                <FormControl
                  name="phoneNumber"
                  type="text"
                  value={slsItem.phoneNumber}
                  onChange={this.handleItemChange}
                />
              </Col>
            </FormGroup>

            <FormGroup controlId="slsItemForm3">
              <Col componentClass={ControlLabel} sm={2}>
                Created By
              </Col>
              <Col sm={2}>
                <FormControl
                  name="createUser"
                  type="text"
                  value={slsItem.createUser}
                  onChange={this.handleItemChange}
                />
              </Col>
              <Col componentClass={ControlLabel} sm={3}>
                Create Time Stamp
              </Col>
              <Col sm={4}>
                <FormControl
                  name="createTimeStamp"
                  type="text"
                  value={slsItem.createTimeStamp}
                  onChange={this.handleItemChange}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="slsItemForm4">
              <Col componentClass={ControlLabel} sm={2}>
                Last Modified By
              </Col>
              <Col sm={2}>
                <FormControl
                  name="lastModifiedUser"
                  type="text"
                  value={slsItem.lastModifiedUser}
                  onChange={this.handleItemChange}
                />
              </Col>
              <Col componentClass={ControlLabel} sm={3}>
                Last Modified Time Stamp
              </Col>
              <Col sm={4}>
                <FormControl
                  name="lastModifiedTimeStamp"
                  type="text"
                  value={slsItem.lastModifiedTimeStamp}
                  onChange={this.handleItemChange}
                />
              </Col>
            </FormGroup>
            <label>PTC Verify</label>
            <FormGroup controlId="slsItemForm5">
              <Col componentClass={ControlLabel} sm={2}>
                Code
              </Col>
              <Col sm={2}>
                <FormControl
                  name="ptcVerifyCode"
                  type="number"
                  value={slsItem.ptcVerifyCode}
                  onChange={this.handleItemChange}
                  disabled={true}
                />
              </Col>
              <Col componentClass={ControlLabel} sm={2}>
                Message
              </Col>
              <Col sm={5}>
                <FormControl
                  name="ptcVerifyMessage"
                  type="text"
                  value={slsItem.ptcVerifyMessage}
                  onChange={this.handleItemChange}
                  disabled={true}
                />
              </Col>
            </FormGroup>
            <label>GUIDS</label>
            <div className="container inheritwidth">
              {trackGuids}
              <Button
                id="addTrackGuidButton"
                onClick={this.addGuid}
                bsSize="small"
                bsStyle="info"
              >
                New Guid
              </Button>
            </div>
            <br />
            <label>DISPATCHERS</label>
            <div className="container inheritwidth">{dispatcherItems}</div>
          </div>
        );
      } else if (slsItem.restrictionDetail.type === "C") {
        formThree = (
          <div>
            <FormGroup controlId="slsItemForm3">
              <Col componentClass={ControlLabel} sm={2}>
                Created By
              </Col>
              <Col sm={2}>
                <FormControl
                  name="createUser"
                  type="text"
                  value={slsItem.createUser}
                  onChange={this.handleItemChange}
                />
              </Col>
              <Col componentClass={ControlLabel} sm={3}>
                Create Time Stamp
              </Col>
              <Col sm={4}>
                <FormControl
                  name="createTimeStamp"
                  type="text"
                  value={slsItem.createTimeStamp}
                  onChange={this.handleItemChange}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="slsItemForm4">
              <Col componentClass={ControlLabel} sm={2}>
                Last Modified By
              </Col>
              <Col sm={2}>
                <FormControl
                  name="lastModifiedUser"
                  type="text"
                  value={slsItem.lastModifiedUser}
                  onChange={this.handleItemChange}
                />
              </Col>
              <Col componentClass={ControlLabel} sm={3}>
                Last Modified Time Stamp
              </Col>
              <Col sm={4}>
                <FormControl
                  name="lastModifiedTimeStamp"
                  type="text"
                  value={slsItem.lastModifiedTimeStamp}
                  onChange={this.handleItemChange}
                />
              </Col>
            </FormGroup>

            {subdivisions}
            <label>Comments</label>
            <div>
              <textarea
                id="formCText"
                rows={10}
                cols={62}
                value={restrictionText}
              />
            </div>
          </div>
        );
      }

      slsItemForm = (
        <Modal
          bsSize="large"
          onHide={this.handleItemFormClose}
          show={true}
          dialogClassName="sls-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Grit Item GR{slsItem.syncId}. DB Item Id:{slsItem.id}
            </Modal.Title>
          </Modal.Header>

          <div className="modal-body">
            <Form horizontal>
              <FormGroup controlId="slsItemForm1">
                <Col componentClass={ControlLabel} sm={1}>
                  SyncId
                </Col>
                <Col sm={2}>
                  <FormControl
                    name="syncId"
                    type="number"
                    value={slsItem.syncId}
                    onChange={this.handleItemChange}
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={2}>
                  Control Number
                </Col>
                <Col sm={1}>
                  <FormControl
                    name="controlNumber"
                    type="text"
                    value={slsItem.restrictionDetail.controlNumber}
                    onChange={this.handleItemRestrictionDetailChange}
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={1}>
                  Type
                </Col>
                <Col componentClass={ControlLabel} sm={1}>
                  {slsItem.restrictionDetail.type}
                </Col>
                <Col componentClass={ControlLabel} sm={1}>
                  Data Version
                </Col>
                <Col sm={2}>
                  <FormControl
                    name="gritVersion"
                    type="number"
                    value={slsItem.gritVersion}
                    onChange={this.handleItemChange}
                  />
                </Col>
              </FormGroup>
              <FormGroup controlId="slsItemForm2">
                <Col componentClass={ControlLabel} sm={1}>
                  Status
                </Col>
                <Col sm={2}>
                  <FormControl
                    name="status"
                    type="text"
                    value={slsItem.status}
                    onChange={this.handleItemChange}
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={2}>
                  Pending Action
                </Col>
                <Col sm={1}>
                  <FormControl
                    name="pendingAction"
                    type="text"
                    value={slsItem.pendingAction}
                    onChange={this.handleItemChange}
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={2}>
                  TSS Return Code
                </Col>
                <Col sm={1}>
                  <FormControl
                    name="tssReturnCode"
                    type="text"
                    value={slsItem.tssReturnCode}
                    onChange={this.handleItemChange}
                  />
                </Col>
              </FormGroup>

              <FormGroup controlId="slsItemForm2">
                <Col componentClass={ControlLabel} sm={2}>
                  Subdivision
                </Col>
                <Col sm={1}>{slsItem.restrictionDetail.subdivision}</Col>
                <Col componentClass={ControlLabel} sm={2}>
                  Issued Time
                </Col>
                <Col sm={3}>
                  <FormControl
                    name="effectiveTimeStamp"
                    type="text"
                    value={slsItem.restrictionDetail.effectiveTimeStamp}
                    onChange={this.handleItemRestrictionDetailChange}
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={2}>
                  Time Zone
                </Col>
                <Col sm={1}>
                  <FormControl
                    name="timezone"
                    type="text"
                    value={slsItem.restrictionDetail.timezone}
                    onChange={this.handleItemRestrictionDetailChange}
                  />
                </Col>
              </FormGroup>

              <FormGroup controlId="slsItemForm2">
                <Col componentClass={ControlLabel} sm={1}>
                  StartMp
                </Col>
                <Col sm={2}>
                  <FormControl
                    name="workStartMp"
                    type="text"
                    value={slsItem.restrictionDetail.workStartMp}
                    onChange={this.handleItemRestrictionDetailChange}
                  />
                </Col>
                <Col sm={1}>
                  <FormControl
                    name="workStartMpSuffix"
                    type="text"
                    value={slsItem.restrictionDetail.workStartMpSuffix}
                    onChange={this.handleItemRestrictionDetailChange}
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={1}>
                  EndMp
                </Col>
                <Col sm={2}>
                  <FormControl
                    name="workEndMp"
                    type="text"
                    value={slsItem.restrictionDetail.workEndMp}
                    onChange={this.handleItemRestrictionDetailChange}
                  />
                </Col>
                <Col sm={1}>
                  <FormControl
                    name="workEndMpSuffix"
                    type="text"
                    value={slsItem.restrictionDetail.workEndMpSuffix}
                    onChange={this.handleItemRestrictionDetailChange}
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={1}>
                  Dir
                </Col>
                <Col sm={1}>
                  <FormControl
                    name="tmTblDirection"
                    type="text"
                    value={slsItem.restrictionDetail.tmTblDirection}
                    onChange={this.handleItemRestrictionDetailChange}
                  />
                </Col>
              </FormGroup>

              {formThree}
            </Form>
          </div>
          <div className="modal-footer">
            <Button
              id="openResendButton"
              onClick={this.handleResendButtonClick}
            >
              Resend
            </Button>
            <Button
              id="submitItemFormButton"
              bsStyle="primary"
              onClick={this.handleItemFormSubmit}
            >
              Update
            </Button>
            <Button
              id="cancelItemFormButton"
              onClick={this.handleItemFormClose}
            >
              Close
            </Button>
          </div>
        </Modal>
      );
    }

    if (this.state.resendItem != null) {
      let resendItem = this.state.resendItem;

      resendForm = (
        <Modal size="sm" onHide={this.handleResendClose} show={true}>
          <Modal.Header closeButton>
            <Modal.Title> Resend GRIT Item GR{resendItem.syncId}</Modal.Title>
          </Modal.Header>
          <Form horizontal>
            <Col componentClass={ControlLabel} sm={2}>
              PrintLata
            </Col>
            <Col sm={3}>
              <FormControl
                id="printLata"
                name="printlata"
                type="text"
                value={this.state.resendPrintLata}
                onChange={this.handleLataChange}
              />
            </Col>
          </Form>
          <div className="modal-footer">
            <Button
              id="submitResendFormButton"
              bsStyle="primary"
              onClick={this.handleResendSubmit}
              disabled={this.state.disableResend}
            >
              Resend
            </Button>
            <Button id="cancelItemFormButton" onClick={this.handleResendClose}>
              Close
            </Button>
          </div>
        </Modal>
      );
    }

    var content = "Loading....";

    if (this.state.isLoading) {
      content = "Loading....";
    } else {
      content = (
        <div style={{ height: "95%" }}>
          <AutoSizer>
            {({ height, width }) => (
              <Table
                ref="Table"
                headerClassName="headerColumn"
                width={width}
                height={height}
                headerHeight={30}
                overscanRowCount={10}
                rowHeight={23}
                rowCount={list.length}
                rowClassName={this._rowClassName}
                noRowsRenderer={this._noRowsRenderer}
                sort={this._sort}
                onRowDoubleClick={this._onRowDoubleClick}
                rowGetter={({ index }) => list[index]}
              >
                <Column
                  width={width * 0.07}
                  label="Subdivision"
                  dataKey="subdivision"
                />
                <Column width={width * 0.07} label="Sync Id" dataKey="syncId" />
                <Column
                  width={width * 0.07}
                  label="Restr#"
                  dataKey="controlNumber"
                />
                <Column width={width * 0.07} label="Status" dataKey="status" />
                <Column
                  width={width * 0.07}
                  label="Action"
                  dataKey="pendingAction"
                />
                <Column width={width * 0.07} label="Type" dataKey="type" />
                <Column
                  width={width * 0.07}
                  label="TSS Code"
                  dataKey="tssReturnCode"
                />
                <Column
                  width={width * 0.07}
                  label="Version"
                  dataKey="gritVersion"
                />
                <Column
                  width={width * 0.15}
                  label="Last Modified"
                  dataKey="lastModifiedTimeStamp"
                  cellRenderer={this.formatValue}
                />
                <Column
                  width={width * 0.04}
                  cellRenderer={this._historyButtonRenderer}
                  dataKey="syncId"
                />
              </Table>
            )}
          </AutoSizer>
        </div>
      );
    }

    return (
      <div className="positionUnderHeader" style={{ height: "100%" }}>
        {content}
        {slsItemForm}
        {resendForm}
      </div>
    );
  },
});

var GuidRow = new createReactClass({
  render: function () {
    var idId = "guidNumber_" + this.props.row;
    var trackId = "trackName_" + this.props.row;
    var bmpId = "startMp_" + this.props.row;
    var empId = "endMp_" + this.props.row;
    var dbVrnId = "dbVersion_" + this.props.row;
    var ptcVrnId = "ptcVersion_" + this.props.row;
    var suffixId = "mpSuffix_" + this.props.row;

    return (
      <div className="row">
        <div>
          <label>ID:</label>
          <input
            type="text"
            id={idId}
            name="guidIdInput"
            style={{ width: "4em" }}
            value={this.props.guid.guidNumber}
            onChange={this.props.onChange}
          />
          <label>Name:</label>
          <input
            type="text"
            id={trackId}
            name="guidNameInput"
            style={{ width: "9em" }}
            value={this.props.guid.trackName}
            onChange={this.props.onChange}
          />
          <label>BMP:</label>
          <input
            type="text"
            id={bmpId}
            name="guidBeginMpInput"
            style={{ width: "4em" }}
            value={this.props.guid.startMp}
            onChange={this.props.onChange}
          />
          <label>EMP:</label>
          <input
            type="text"
            id={empId}
            name="guidEndMpInput"
            style={{ width: "4em" }}
            value={this.props.guid.endMp}
            onChange={this.props.onChange}
          />
          <label>Suffix:</label>
          <input
            type="text"
            id={suffixId}
            name="guidMpSuffixInput"
            style={{ width: "1em" }}
            value={this.props.guid.mpSuffix}
            onChange={this.props.onChange}
          />
          <label>TMDS Vsn:</label>
          <input
            type="text"
            id={dbVrnId}
            name="guidDbVsnInput"
            style={{ width: "5em" }}
            value={this.props.guid.dbVersion}
            onChange={this.props.onChange}
          />
          <label>PTC Vsn:</label>
          <input
            type="text"
            id={ptcVrnId}
            name="guidptcVsnInput"
            style={{ width: "9em" }}
            value={this.props.guid.ptcVersion}
            onChange={this.props.onChange}
          />
          <a
            className="btn btn-sm btn-default"
            id=""
            onClick={this.props.rowDelete}
            title="Delete Restriction"
          >
            <span id={this.props.row} className="glyphicon glyphicon-remove" />
          </a>
        </div>
      </div>
    );
  },
});

var DispatcherRow = new createReactClass({
  render: function () {
    var idId = "dispatcherId_" + this.props.row;
    var statusId = "statusCode_" + this.props.row;
    var createTimeId = "ptcVersion_" + this.props.row;

    return (
      <div className="row">
        <div>
          <label>DS ID:</label>
          <input
            type="text"
            id={idId}
            name="dsIdInput"
            style={{ width: "6em" }}
            value={this.props.dispatcher.dispatcherId}
            onChange={this.props.onChange}
          />
          <label>Status Code:</label>
          <input
            type="text"
            id={statusId}
            name="statusIdInput"
            style={{ width: "4em" }}
            value={this.props.dispatcher.statusCode}
            onChange={this.props.onChange}
          />
          <label>Create Time Stamp:</label>
          <input
            type="text"
            id={createTimeId}
            name="createTimeIdInput"
            readOnly={true}
            value={this.props.dispatcher.createTimeStamp}
            onChange={this.props.onChange}
          />
        </div>
      </div>
    );
  },
});

var TrackRow = new createReactClass({
  render: function () {
    var nameId = "name_" + this.props.row;
    var id = "id_" + this.props.row;

    return (
      <div className="row">
        <div>
          <label>Name:</label>
          <input
            type="text"
            disabled={true}
            id={nameId}
            style={{ width: "9em" }}
            value={this.props.track.name}
          />
          <label>ID:</label>
          <input
            type="text"
            disabled={true}
            id={id}
            style={{ width: "4em" }}
            value={this.props.track.id}
          />
        </div>
      </div>
    );
  },
});

var SubdivisionRow = new createReactClass({
  render: function () {
    var nameId = "subdivisionName_" + this.props.row;
    var seqId = "sequenceNumber_" + this.props.row;

    return (
      <div className="row">
        <div>
          <label>Name:</label>
          <input
            type="text"
            id={nameId}
            style={{ width: "6em" }}
            value={this.props.sub.subdivisionName}
            onChange={this.props.onChange}
          />
          <label>Seq:</label>
          <input
            type="text"
            id={seqId}
            style={{ width: "4em" }}
            value={this.props.sub.sequenceNumber}
            onChange={this.props.onChange}
          />
          <a
            className="btn btn-sm btn-default"
            id=""
            onClick={this.props.rowDelete}
            title="Delete Restriction"
          >
            <span id={this.props.row} className="glyphicon glyphicon-remove" />
          </a>
        </div>
      </div>
    );
  },
});

function sortFunction(c1, c2) {
  if (c1.lineNumber < c2.lineNumber) {
    return -1;
  }
  if (c1.lineNumber > c2.lineNumber) {
    return 1;
  }
  // a must be equal to b
  return 0;
}
